import { useState, useEffect } from 'react';
import './ReadyToExplore.css';
import ctaPhoto from '../../assets/whyus_ready_explore.png';

const testimonials = [
  {
    text: "Watt & Wattle made the whole process easy. The team was professional, the installation was flawless, and our bills have dropped significantly. Highly recommend!",
    name: "James R.",
    suburb: "Doncaster, VIC",
    stars: 5,
  },
  {
    text: "From quote to installation, everything was seamless. Our electricity bills dropped by 60% in the first month. Couldn't be happier with the result.",
    name: "Sarah M.",
    suburb: "Frankston, VIC",
    stars: 5,
  },
  {
    text: "Professional, honest and efficient. They explained everything clearly and the system has been running perfectly since day one.",
    name: "David K.",
    suburb: "Berwick, VIC",
    stars: 5,
  },
];

function Stars({ count }) {
  return (
    <div className="cta-stars">
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="18" height="18" viewBox="0 0 16 16" fill="#eaff50">
          <path d="M8 1l1.85 3.75L14 5.5l-3 2.92.71 4.14L8 10.5l-3.71 1.96L5 8.42 2 5.5l4.15-.75z" />
        </svg>
      ))}
    </div>
  );
}

export default function ReadyToExplore() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setActive(i => (i + 1) % testimonials.length), 4500);
    return () => clearInterval(timer);
  }, []);

  const t = testimonials[active];

  return (
    <div className="cta-section">
      <div className="cta-inner">

        {/* Left */}
        <div className="cta-left">
          <span className="cta-label">Get Started</span>
          <h2 className="cta-heading">Ready to explore the right solution for your home?</h2>
          <p className="cta-subtitle">We'll help you compare solar, battery and upgrade options that fit your energy needs and budget.</p>
          <div className="cta-buttons">
            <a href="/residential-solutions" className="cta-button cta-primary">Explore Solutions &nbsp;→</a>
            <a href="/contact" className="cta-button cta-secondary">Request a Free Quote &nbsp;→</a>
          </div>
        </div>

        {/* Right — photo */}
        <div className="cta-right">
          <img src={ctaPhoto} alt="" className="cta-photo" />
        </div>

      </div>
    </div>
  );
}
